import imageCompression from 'browser-image-compression';

// Compress a user-uploaded photo (passport / avatar) to ≤ ~1 MB before
// sending to the presigned-PUT S3 URL.
export async function compressPhoto(file: File): Promise<File> {
  const opts = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
    fileType: file.type === 'image/png' ? ('image/png' as const) : ('image/jpeg' as const),
    initialQuality: 0.85,
  };
  try {
    return await imageCompression(file, opts);
  } catch {
    // Compression failure should not block UX — return original.
    return file;
  }
}
